<template>
  <div id="app">
     <First v-if="step==1"
         :houses="houses"
         :step.sync="step"
         :result.sync="result"
         :first.sync="first"
     ></First>
    <Secound v-if="step==2"
        :houses="houses"
        :step.sync="step"
        :result.sync="result"
    ></Secound>
  </div>
</template>

<script>
import First from './components/first.vue'
import Secound from './components/secound.vue'

export default {
  name: 'App',
  components: {
    First,
    Secound
  },
   data() {
        return {
          result:{
            selected:['0,45',null,null,null,null,null],
            inputs: ['','','','','','','']
          },
          step:1,
          first:true,
          houses:[
            {
              id:1,
              side:1,
              selected:1,
              show:1,
              img:"ereszkalkulator_haz_felnyeregteto_szines.png",
              name:"FÉLNYEREGTETŐ"
            },
             {
              id:2,
              side:2,
              selected:0,
              show:0,
              img:"ereszkalkulator_haz_kontyolt_nyeregteto_szines.png",
              name:"KONTYOLT NYEREGTETŐ"
            },
            {
               id:3,
              side:4,
              selected:0,
              show:0,
              img:"ereszkalkulator_haz_l_nyeregteto_szines.png",
              name:"L NYEREGTETŐ"
            },
            {
               id:4,
              side:1,
              selected:0,
              show:0,
              img:"ereszkalkulator_haz_nyeregteto_szines.png",
              name:"NYEREGTETŐ"
            },
            {
               id:5,
              side:5,
              selected:0,
              show:0,
              img:"ereszkalkulator_haz_osszetett_kontyolt_nyeregteto_szines.png",
              name:"Összetett kontyolt nyeregtető"
            },
             {
               id:6,
              side:4,
              selected:0,
              show:0,
              img:"ereszkalkulator_haz_osszetett_nyeregteto_szines.png",
              name:"ÖSSZETETT NYEREGTETŐ"
            },
          ]
        }
   }
}
</script>
<style>
  #app{
    font-size: 1rem;
    color: black;
    font-family: 'Roboto', sans-serif !important;
  }
  .background{
     background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: 30%;
  }
</style> 